module.exports = __webpack_public_path__ + "static/media/Nav_Dashboard_Gray.70119155.svg";